import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import toast from "react-hot-toast";
import Loader from "../../components/loader";
import LoadingButton from "../../components/loadingButton";
import api from "../../services/api";

const ListBusinessUnit = () => {
  const [businessUnits, setBusinessUnits] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/business_unit");
      setBusinessUnits(data);
    })();
  }, []);

  if (!businessUnits) return <Loader />;

  return (
    <div>
      <div className="w-screen md:w-full pt-6 px-2 md:px-8">
        <div className="mb-4 p-4 bg-purple-50 border border-purple-200 rounded-lg">
          <p className="text-sm text-purple-800">
            Les <strong>business units</strong> representent les equipes operationnelles. Chaque membre de l'equipe est rattache a une business unit qui determine son perimetre de gestion et de reporting.
          </p>
        </div>
        <Create />
        <div className="overflow-x-auto bg-[#fff] rounded-[10px]">
          <table className="w-[800px] md:w-full">
            <thead className="border-b border-[#E5EAEF]">
              <tr className="text-[14px] text-[#212325] font-semibold">
                <th className="py-3 px-3 text-left">Business Unit</th>
                <th className="text-left">Key</th>
                <th className="text-left">Description</th>
                <th className="text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {businessUnits.map((hit) => (
                <tr
                  className="hover:bg-[#f6f6f6] border-b border-[#dee2e6] text-[#676D7C] cursor-pointer text-[14px] font-medium"
                  key={hit._id}
                  onClick={() => navigate(`/business_unit/${hit._id}`)}>
                  <td className="py-[10px] px-[15px] min-w-[80px] flex items-center gap-3">
                    {hit.emoji && <span className="text-lg">{hit.emoji}</span>}
                    {hit.color && <span className="w-3 h-3 rounded-full inline-block" style={{ backgroundColor: hit.color }} />}
                    <div>{hit.name}</div>
                  </td>
                  <td className="min-w-[80px]">
                    <span className="px-2 py-1 text-xs font-mono bg-gray-100 rounded">{hit.key}</span>
                  </td>
                  <td className="min-w-[120px] max-w-[300px]">
                    <span className="text-[13px] text-gray-500 truncate block">{hit.description || "-"}</span>
                  </td>
                  <td className="min-w-[80px]">
                    {hit.status === "active" ? (
                      <span className="px-2 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800">Active</span>
                    ) : (
                      <span className="px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-600">Inactive</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const Create = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div style={{ marginBottom: 10 }}>
      <div className="text-right">
        <button className="bg-[#0560FD] text-[#fff] py-[10px] px-[22px] inline-block rounded-[10px] text-[16px] font-medium" onClick={() => setOpen(true)}>
          Create new business unit
        </button>
      </div>
      {open ? (
        <div className="absolute top-0 bottom-0 left-0 right-0 bg-[#00000066] flex justify-center p-[1rem] z-50" onClick={() => setOpen(false)}>
          <div className="w-full md:w-[60%] h-fit bg-[white] p-[25px] rounded-md" onClick={(e) => e.stopPropagation()}>
            <Formik
              initialValues={{ name: "", key: "", description: "", emoji: "", color: "#3b82f6" }}
              onSubmit={async (values, { setSubmitting }) => {
                try {
                  values.status = "active";
                  const res = await api.post("/business_unit", values);
                  if (!res.ok) throw res;
                  toast.success("Created!");
                  navigate(`/business_unit/${res.data._id}`);
                  setOpen(false);
                } catch (e) {
                  console.log(e);
                  toast.error("Some Error!", e.code);
                }
                setSubmitting(false);
              }}>
              {({ values, handleChange, handleSubmit, isSubmitting }) => (
                <React.Fragment>
                  <div className="flex justify-between flex-wrap">
                    <div className="w-full md:w-[48%] mt-2">
                      <div className="text-[14px] text-[#212325] font-medium">Name</div>
                      <input className="projectsInput text-[14px] font-normal text-[#212325] rounded-[10px]" name="name" value={values.name} onChange={handleChange} />
                    </div>
                    <div className="w-full md:w-[48%] mt-2">
                      <div className="text-[14px] text-[#212325] font-medium">Key (ex: SELEGO)</div>
                      <input className="projectsInput text-[14px] font-normal text-[#212325] rounded-[10px]" name="key" value={values.key} onChange={handleChange} />
                    </div>
                    <div className="w-full md:w-[48%] mt-2">
                      <div className="text-[14px] text-[#212325] font-medium">Emoji</div>
                      <input className="projectsInput text-[14px] font-normal text-[#212325] rounded-[10px]" name="emoji" value={values.emoji} onChange={handleChange} />
                    </div>
                    <div className="w-full md:w-[48%] mt-2">
                      <div className="text-[14px] text-[#212325] font-medium">Color</div>
                      <input type="color" className="h-[38px] w-full rounded-[10px] cursor-pointer" name="color" value={values.color} onChange={handleChange} />
                    </div>
                    <div className="w-full mt-2">
                      <div className="text-[14px] text-[#212325] font-medium">Description</div>
                      <textarea
                        className="w-full rounded-md border-[1px] bg-[#ffffff] border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 md:text-sm placeholder:text-gray-300 py-2 px-2"
                        rows="3"
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <br />
                  <LoadingButton
                    className="mt-[1rem] bg-[#0560FD] text-[16px] font-medium text-[#FFFFFF] py-[12px] px-[22px] rounded-[10px]"
                    loading={isSubmitting}
                    disabled={!values.name || !values.key}
                    onClick={handleSubmit}>
                    Save
                  </LoadingButton>
                </React.Fragment>
              )}
            </Formik>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ListBusinessUnit;
